import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { logout } from "../../../Dashboard/actions/auth";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
}));

const AppBarDisplayShort = ({ logout, page }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography
        component="h1"
        variant="h6"
        color="inherit"
        noWrap
        className={classes.title}
      >
        {page}
      </Typography>
      {/* <IconButton color="inherit">
          <Badge badgeContent={4} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton> */}
      <div>
        <button
          type="button"
          className="btn btn-danger"
          onClick={logout}
          style={{
            textAlign: "center",
            overflow: "visible",
            backgroundImage:
              "linear-gradient(to bottom left, #FF8941, #db3157,#cc0132)",
          }}
        >
          X
        </button>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  page: state.toolbar.page,
});

export default connect(mapStateToProps, { logout })(AppBarDisplayShort);
